import { ReplaySubject, Subject } from 'rxjs'

export const redirectSubject = new Subject()
export const scrollToItem = new Subject()
export const neededFiltersTip = new Subject()
export const fileUploadSubject = new Subject()
export const electronFileDownloadedSubject = new Subject()

export const onboardingSubject = new ReplaySubject(1)
